<!--首页-->
<template>
  <div class='answer-question lg-contain-background'>
    <category :category_list="category_list" :active_category="active_category" @select="handleSelectCategory"/>
    <div class="answer-question-body">
      <div class="list">
        <div class="question-list" v-if="question_list.length !== 0">
          <div class="question-list-item" v-for="item in question_list" :key="item.id"
               @click="handleQuizDetail(item.id)">
            <p class="title">{{ item.title }}</p>
            <div class="user-info">
              <img class="avatar" :src="item.user_avatar_info" alt="">
              <div>
                <p class="name">{{ item.user_name }}</p>
              </div>
            </div>
            <div class="describe">{{ item.subQuestion[0].describe }}</div>
          </div>
        </div>
        <zg-404 v-if="showNotData"/>
      </div>
      <div class="right">
        <div :class="user_info.expert_attest_status === 1 ? 'operation':'operation operations' ">
          <div class="item" @click="handleOpenPages('my_question')">
            <el-badge :value="user_info.question_not_reply_count" class="item"
                      v-if="user_info.question_not_reply_count !== 0">
              <img src="../../assets/img/found/icon-question.png" alt="">
            </el-badge>
            <img src="../../assets/img/found/icon-question.png" v-else alt="">
            <p>我的问题</p>
          </div>
          <div class="item" @click="handleOpenPages('my_answer')" v-if="user_info.expert_attest_status === 1">
            <el-badge :value="user_info.unanswered_count" class="item" v-if="user_info.unanswered_count !== 0">
              <img src="../../assets/img/found/icon-answer.png" alt="">
            </el-badge>
            <img src="../../assets/img/found/icon-answer.png" alt="" v-else>
            <p>我的回答</p>
          </div>
          <div class="item" @click="handleOpenPages('expert_list')">
            <img src="../../assets/img/found/icon-quiz.png" alt="">
            <p>去提问</p>
          </div>
        </div>
        <div class="rec" v-if="rec_list.length !== 0">
          <p class="rec-title">专家推荐</p>
          <div class="rec-list">
            <div class="rec-list-item" v-for="item in rec_list" :key="item.id" @click.stop="handleDetail(item.user_id)">
              <div>
                <el-avatar shape="square" class="avatar" :src="item.avatar_info"></el-avatar>
              </div>
              <div>
                <div style="display: flex">
                  <p class="lg-list-title hide_small lg-text-ell">{{ item.nickname }}</p>
                  <p class="lg-list-item hide_small nickname lg-text-ell">{{ item.job_title }}</p>
                </div>
                <p class="lg-list-item hide lg-text-ell">{{ item.work }}</p>
                <div class="rate">
                  <p class="score">
                    <i class="el-icon-star-on"></i>
                    <span class="num">{{ item.answer_rate }}</span>
                  </p>
                  <p class="lg-list-item division">|</p>
                  <p class="lg-list-item info">{{ item.answer_count }}个回答</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import category from '../../components/category/index'

export default {
  name: "index",
  components: {category},
  data() {
    return {
      user_info: {},
      // 分类列表
      category_list: [],
      // 当前激活分类id
      active_category: [],
      // 问题列表
      question_list: [],
      // 推荐专家列表
      rec_list: [],
      /* 总条数 */
      total: 0,
      /* 待处理数量 */
      handle_num: 0,
      // 请求列表参数
      showNotData: false,
      Form: {
        page: 1,
        page_size: 10,
        category_id: 'all'
      }
    }
  },
  created() {
    this.$store.state.status.blank_text = '暂无内容，快去发表你的提问吧！'
    this.user_info = localStorage.getItem('user-info') ? JSON.parse(localStorage.getItem('user-info')) : {}
    this.$requestApi.expert.expert_categories().then(res => {
      res.data.unshift({id: 'all', name: "全部", children: []})
      this.category_list.push(res.data)
      this.active_category.push('all')
    })
    this.handleGetList()
    this.$requestApi.expert.expert_list({is_rec: 1}).then(res => this.rec_list = res.data)
    window.addEventListener('scroll', this.handleScroll, true)
    this.$Bus.$off('question_answer').$on('question_answer', value => {
      this.$requestApi.api.userInfo().then(res => this.user_info = res.data)
    })
  },
  methods: {
    // 分页
    handleScroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = (document.documentElement.scrollHeight || document.body.scrollHeight);
      //滚动条到底部的条件
      if (scrollHeight - (scrollTop + windowHeight) < 150) {
        if (this.question_list.length === this.total) return
        this.Form.page += 1
        this.$requestApi.expert.expert_question_list(this.Form).then(res => this.question_list = this.question_list.concat(res.data))
      }
    },
    // 选择分类
    handleSelectCategory(info) {
      let {data, index} = info
      this.active_category[index] = data.id
      this.Form.category_id = data.id
      this.Form.page = 1
      this.handleGetList()
      this.category_list.splice(index + 1)
      if (data.children.length !== 0) {
        if (data.children[0].name.indexOf('全部') === -1) {
          data.children.unshift({id: 'all' + index, name: "全部", children: []})
        }
        this.category_list[index + 1] = data.children
        this.active_category[index + 1] = data.children[0].id
      }
    },
    // 获取列表
    handleGetList() {
      if (typeof this.Form.category_id === "string" && this.Form.category_id.indexOf('all') !== -1) {
        delete this.Form.category_id
      }
      // if (this.Form.category_id === 'all')delete this.Form.category_id
      this.$requestApi.expert.expert_question_list(this.Form).then(res => {
        this.question_list = res.data
        this.total = res.meta.total
        if (this.question_list.length == 0) {
          this.showNotData = true
        }
      })
    },
    handleOpenPages(name) {
      if (name === 'expert_list') {
        this.$router.push({name: name, query: {id: 'expert'}})
      } else if (this.$utils.loginStatus()) {
        this.$router.push({name: name, query: {id: 'expert'}})
      }
    },
    /* 专家主页 */
    handleDetail(id) {
      this.$router.push({name: "expert_home", query: {id: id}})
    },
    /* 问题详情 */
    handleQuizDetail(data) {
      this.$router.push({name: 'detail_index', query: {id: data}})
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true)
  }
}
</script>

<style scoped lang='less'>
.answer-question {
  /deep/ .no-content {
    margin-top: 15px;
  }

  &-body {
    padding: 0 240px;
    overflow: hidden;
    position: relative;
    width: 100%;
    display: flex;
    margin-bottom: 30px;

    .list {
      width: 1130px;

      .question-list {
        &-item {
          background-color: #ffffff;
          padding: 20px 20px 10px;
          border-radius: 6px;
          margin-top: 15px;
          cursor: pointer;

          .title {
            font-weight: bold;
            margin-bottom: 10px;
          }

          .user-info {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .avatar {
              width: 42px;
              height: 42px;
              margin-right: 10px;
              border-radius: 50%;
            }
          }

          .describe {
            font-size: 14px;
            line-height: 26px;
            display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
            -webkit-box-orient: vertical; //设置或检索伸缩盒对象的子元素的排列方式
            -webkit-line-clamp: 3; //一个块元素显示的文本的行数
            overflow: hidden; //溢出隐藏
          }
        }
      }
    }

    .right {
      margin-left: 22px;

      .operation {
        width: 300px;
        height: 120px;
        background-color: #ffffff;
        padding: 20px;
        border-radius: 6px;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item {
          cursor: pointer;
          text-align: center;

          img {
            width: 60px;
            height: 60px;
          }

          p {
            margin-top: 10px;
            color: #666666;
            font-size: 14px;
          }

          /deep/ .el-badge__content.is-fixed {
            right: 20px;
            height: auto;
            line-height: normal;
            padding-top: 1px;
          }
        }
      }

      .operations {
        justify-content: space-around;
      }

      .rec {
        width: 300px;

        &-title {
          margin-top: 20px;
        }

        &-list {
          &-item {
            cursor: pointer;
            width: 100%;
            padding: 13px 10px;
            background: #FFFFFF;
            border-radius: 6px;
            margin-top: 20px;
            display: flex;
            align-items: center;

            .avatar {
              width: 68px;
              height: 68px;
              margin-right: 10px;
            }

            .nickname {
              margin: 2px 0 2px 4px;
            }

            .hide {
              max-width: 175px;
              margin: 2px 0;
            }

            .hide_small {
              max-width: 97px;
            }

            .rate {
              display: flex;
              align-items: center;

              .score {
                .num {
                  font-size: 13px;
                  color: #ffde00;
                }

                .el-icon-star-on {
                  color: #ffde00;
                  font-size: 18px;
                }
              }

              .info {
                font-size: 13px;
              }

              .division {
                margin: 0 4px;
              }
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/answerQuestion/index.vue